export default __webpack_public_path__ + "static/media/c002-PPII-14.15c73ed7.svg";